import { Component, Input } from '@angular/core';
import { Skeleton } from './skeleton';

@Component({
	imports: [Skeleton],
	selector: 'skeletons',
	templateUrl: './skeletons.html'
})
export class Skeletons {
	@Input() customSkeletons = new Array<Array<string>>(); // e.g. [['1em', '60%'], ['1em', '80%'], ['1em', '100%']] and add 3rd element for classes 
	@Input() set defaultSkeletons(amount: number) {
		this.requestedDefaultSkeletons = new Array(amount);
		for (let i = 0; i < amount; i++) this.requestedDefaultSkeletons[i] = {};
	}

	requestedDefaultSkeletons: {}[] = [];
}
